import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, message, Button, Carousel, Checkbox } from 'antd';
import { QuestionCircleFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import qs from 'qs';
import CryptoJS from 'crypto-js';
import {
  _get_user_info,
  _dssp_send_click,
  _h5_link_to,
  _change_phone_modal,
  _anly_seng_custom,
} from '../../store/Action';
import Util from '../../script/util';
import ConfrimIframeModal from '../iframModal/ConfrimIframeModal';
import MaxIframeModal from '../iframModal/MaxIframModal';
import CodePay from '../codePay/CodePay';
import HTTP from '../../script/service';
import FirstRechargeSuccess from '../firstCharge/FirstRechargeSuccess';
import IframeModal from '../iframModal/IframModal';
import ShModal from '../shModal/shModal';
import store from '../../store/store';
import { redirectToCheckout, loadAirwallex } from 'airwallex-payment-elements';
import './Recharge.scss';

class Recharge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      selAdArray: null,
      otherAdItem: {
        index: 7,
        diamondAmount: 0,
        price: '',
      },
      loading: false,
      areaListType: [], // 地区列表
      areaType: null, // 地区选择
      payList: null, // 支付方式列表
      payId: null, // 选中的支付方式
      // payType: 2, //微信2 支付宝1
      payType: 5, //h5 微信5 支付宝7
      action: 1, //1钱包 2语聊大厅 3开箱 4下单 5买背景
      areaCharConfig: [],
      isRechargeAgreement: true, // 是否勾选充值协议
      firstChargeTime: 0, // 首充倒计时
      tipVisible: false,
      isAgree: true,
      isAgree2: true,
      isAgree3: true,
    };
  }

  //获取充值金额的配置
  getChargeConfig = (area) => {
    HTTP._get_charge_config({
      paySource: 1, //1.web 2.android 3.ios
      lang_area: area, //默认人民币充值
    })
      .then((res) => {
        if (res?.code === 200) {
          let defaultSelAd = res.data[0];
          if (area === 'CN' && this.state.otherAdItem.price > 0) {
            defaultSelAd = this.state.otherAdItem;
          }
          this.setState({
            areaCharConfig: res.data,
            selAdArray: defaultSelAd,
          });
        } else {
          this.setState({
            areaCharConfig: [],
            selAdArray: null,
          });
        }
      })
      .catch((err) => {
        this.setState({
          areaCharConfig: [],
          selAdArray: null,
        });
      });
  };

  showRealModal = (action, money) => {
    money = money?.toFixed?.(2) || 0;
    let param = {
      visible: true,
      action: action,
      money: money,
      selAdArray:
        this.state.areaCharConfig.length > 0
          ? this.state.areaCharConfig[0]
          : {
              area: 'CN',
              amount: 500,
              createTime: 1582887222000,
              price: 5,
              paySource: 1,
              id: 'web_daidai_CN_5',
              saleStatus: 1,
              channelId: '1000',
            },
      otherAdItem: {
        index: 7,
        diamondAmount: 0,
        price: '',
      },
    };
    if (money) {
      if (this.state.payType == 5 && money > 99999) {
        money = 99999;
      }
      if (this.state.payType == 7 && money > 20000) {
        money = 20000;
      }
      param.selAdArray = {
        index: 7,
        diamondAmount: 0,
        price: money,
      };
      param.otherAdItem = {
        index: 7,
        diamondAmount: 0,
        price: money,
      };
    }
    this.setState(param, () => {
      this.showFirstRecharge();
    });
  };

  getArea = () => {
    const { payType } = this.state;
    let area = '';
    if (payType == 5 || payType == 7) {
      area = 'CN';
    } else if (payType == 23) {
      area = 'US';
    } else if (payType == 24) {
      area = 'TW';
    }
    return area;
  };

  showModal = (action, money) => {
    const that = this;
    let defaultAreaType = 'CN_INLAND';
    if (this.props.base.rootConfig.lang == 'zh_CN') {
      start(defaultAreaType, null);
      this.getPayConfigByAreas(defaultAreaType);
    } else {
      HTTP._get_pay_areas().then((res) => {
        if (res?.code === 200 && !!res.data.length) {
          defaultAreaType = res.data[0].area;
          start(defaultAreaType, res.data);
          this.getPayConfigByAreas(defaultAreaType);
        }
      });
    }

    function start(areaType, areaListType) {
      that.setState({ areaType, areaListType }, () => {
        that.showRealModal(action, money);
      });
    }
  };
  // 获取该地区拥有的支付方式
  getPayConfigByAreas = (area) => {
    // dataSource 	1-PC,2-APP,3-H5
    const { isChannelSHWB } = this.props.base;
    let params = isChannelSHWB
      ? { dataSource: 1, area, configType: 1 }
      : { area, dataSource: 1 };
    (isChannelSHWB
      ? HTTP._get_pay_config_by_areas_sh
      : HTTP._get_pay_config_by_areas)(params).then((res) => {
      if (res.code === 200 && !!res.data.length) {
        const defaultPayType = res.data[0].payType;
        const defaultPayId = res.data[0].id;
        this.setState(
          { payId: defaultPayId, payType: defaultPayType, payList: res.data },
          () => {
            this.getPayItemByConfig(defaultPayId);
          }
        );
      }
    });
  };
  // 获取充值包下所有的充值配置
  getPayItemByConfig = (configId) => {
    const { payType, otherAdItem } = this.state;
    const { isChannelSHWB } = this.props.base;
    let params = isChannelSHWB ? { configType: 1, configId } : { configId };
    (isChannelSHWB
      ? HTTP._get_pay_item_by_config_sh
      : HTTP._get_pay_item_by_config)(params).then((res) => {
      let areaCharConfig = [];
      let defaultSelAd = null;
      if (res.code === 200 && !!res.data.length) {
        if ((payType == 5 || payType == 7) && otherAdItem.price > 0) {
          let money = otherAdItem.price;
          if (payType == 5 && money > 99999) {
            money = 99999;
          }
          if (payType == 7 && money > 20000) {
            money = 20000;
          }
          this.setState({ otherAdItem: { ...otherAdItem, price: money } });
          defaultSelAd = { ...otherAdItem, price: money };
        } else {
          defaultSelAd = res.data[0];
        }
        areaCharConfig = res.data;
      }
      this.setState({ selAdArray: defaultSelAd, areaCharConfig });
    });
  };
  // 首充倒计时
  firstChargeDown = (downTime = 0) => {
    clearTimeout(this.timer);
    if (downTime < 0) {
      this.setState({ firstChargeTime: 0 });
    } else {
      this.timer = setTimeout(() => {
        this.setState({ firstChargeTime: downTime - 1000 });
        this.firstChargeDown(downTime - 1000);
      }, 1000);
    }
  };
  hideModal = () => {
    clearTimeout(this.timer);
    clearTimeout(this.carouseTime);
    this.setState({
      visible: false,
    });
  };
  // 展示首充弹窗
  showFirstRecharge = async () => {
    const { uid, userInfo } = this.props.base;
    if (!!userInfo.userFit && userInfo.userFit === 1) {
      // 获取用户是否支持首充有礼
      HTTP._get_first_recharge_activity({ uid }).then((res) => {
        if (res?.code === 200 && !!res.data?.userFit) {
          const { activityItems } = res.data;
          const first = activityItems[0];
          const downCount = first.activityEndTime - first.curTime;
          if (downCount > 0) {
            this.setState({ firstChargeTime: downCount });
            this.firstChargeDown(downCount);

            const isFirstModal = Util.readCookie('is_first_modal');
            // 从充值弹窗中打开的首充页面
            if (!isFirstModal) {
              Util.setCookie('is_first_modal', 1, 1);
              store.dispatch({
                type: 'set_is_show_first_recharge',
                data: {
                  showFirstReCharge: {
                    visible: true,
                    recharge: true,
                    data: { ...res.data, downCount }, // 缓存数据，避免重复调用
                  },
                },
              });
            }

            // 由于动态更新时间，导致轮播无法自动播放，则需要手动播放
            this.autoplayCarouse();
          }
        }
      });
    }
  };
  autoplayCarouse = () => {
    clearTimeout(this.carouseTime);
    if (this.rechargeCarouselEle) {
      this.carouseTime = setTimeout(() => {
        this.rechargeCarouselEle.next();
        this.autoplayCarouse();
      }, 3000);
    }
  };
  setAdArray = (item) => {
    this.setState({
      selAdArray: { ...item },
    });
  };
  changeFormValue = (e) => {
    let newText = parseInt(e.target.value.replace(/[^\d]+/, ''));
    if (!newText || newText === '' || isNaN(newText)) {
      newText = '';
    }
    if (this.state.payType == 7 && newText != '') {
      if (parseInt(newText) > 20000) {
        newText = '20000';
      }
    }
    const item = {
      index: 7,
      diamondAmount: 0,
      price: newText,
    };
    this.setState({
      otherAdItem: item,
      selAdArray: item,
    });
  };
  changeAreaType = (area) => {
    this.setState({ areaType: area.area });
    this.getPayConfigByAreas(area.area);
  };
  changePayType = (t) => {
    if (!t) return;
    const { payType, id } = t;
    const { otherAdItem } = this.state;

    if (payType == 5 || payType == 7) {
      if (
        otherAdItem.price &&
        otherAdItem.price != '' &&
        otherAdItem.price > 20000
      ) {
        otherAdItem.price = 20000;
      }
    }
    this.setState({ payId: id, payType, otherAdItem }, () => {
      this.getPayItemByConfig(id);
    });
  };
  showRemark = () => {
    this.confirmElement.showModal({
      url: this.props.base.rootConfig.mobilePath + '/currencydesc/index.html',
      title: '货币说明',
      scrolling: 'no',
      width: '750px',
      height: '490px',
      zIndex: 1006,
    });
  };
  //发起支付
  toCodePay = () => {
    const { userInfo, rootConfig, isChannelSHWB } = this.props.base;
    //强制必须绑定手机
    if (
      (!userInfo.bindPhone || userInfo.bindPhone == '') &&
      rootConfig.lang == 'zh_CN'
    ) {
      _change_phone_modal(true);
      return;
    }
    const { selAdArray, payType, isRechargeAgreement } = this.state;
    if (!selAdArray || !selAdArray.price) {
      message.warning('请填写或选择你要充值的金额。');
      return false;
    }
    if (!isRechargeAgreement) {
      message.warning('请先同意充值服务协议');
      return false;
    }
    this.setState({
      loading: true,
    });

    if (isChannelSHWB) {
      this.setState({
        visible: false,
        loading: false,
      });
      if (window.localStorage.getItem('isShTips')) {
        this.toShPay();
      } else {
        this.shElement.showTipModal();
      }
    } else {
      if (payType == 5 || payType == 7) {
        this.payForNormal();
      } else {
        this.payForOversea();
      }
    }
  };

  //国内支付方式
  payForNormal = () => {
    const { rootConfig, uid, clientInfo, channelId } = this.props.base;
    const { selAdArray, payType, action } = this.state;

    const params = {
      uid,
      tgid: clientInfo.tgid || '',
      payFee: selAdArray.price,
      diamond: selAdArray.amount,
      payType,
      action,
      origin: 1, // 来源，判断跳转地址  1:PC 2:H5 3:公众号
    };
    HTTP._recharge_v4_pay(params)
      .then((res) => {
        if (res?.code === 200) {
          const hOid = res.data;
          const h5Params = {
            uid,
            type: payType,
            amount: selAdArray.amount,
            price: selAdArray.price,
            hOid,
            channelId,
            origin: 1,
            action,
            tgid: clientInfo.tgid || '',
          };
          const gid = Util.getReportParams('gid');
          const mac = Util.getReportParams('mac');
          const pcname = Util.getReportParams('pcname');
          const bootid = Util.getReportParams('bootid');
          if (gid) h5Params.gid = gid;
          if (mac) h5Params.mac = mac;
          if (pcname) h5Params.pcname = pcname;
          if (bootid) h5Params.bootid = bootid;
          const url = `${rootConfig.mobilePath}/h5charge?${qs.stringify(h5Params)}`;
          this.payElement.show({
            url,
            uid,
            payType,
            orderId: hOid,
            action: params.action,
            price: selAdArray.price,
          });
        } else {
          message.error(res?.message || '充值异常，请稍后重试哦~');
          _anly_seng_custom('recharge_error', { data: { params, err: res } });
        }
      })
      .catch((err) => {
        _anly_seng_custom('recharge_error', {
          data: { params, err: err.toString() },
        });
        message.error('充值异常，请稍后重试哦~');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  //海外支付方式
  payForOversea = () => {
    const { selAdArray } = this.state;
    let timestamp = new Date().getTime();
    let returnUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      '/payCallback.html';
    let sign =
      this.props.base.uid +
      selAdArray.id +
      this.state.payType +
      timestamp +
      returnUrl +
      'wp#^@Sd&hms';
    sign = CryptoJS.MD5(sign).toString();
    HTTP._oversea_pay({
      uid: this.props.base.uid,
      payFee: selAdArray.price,
      payType: this.state.payType,
      action: this.state.action,
      itemId: selAdArray.id,
      timestamp: timestamp,
      sign: sign,
      returnUrl: returnUrl,
    }).then(async (res) => {
      this.setState({ loading: false });
      if (res?.code === 200 && res?.data?.payRes && res.data.payRes?.body) {
        //airwallex 支付
        if (this.state.payType == 39) {
          const body = JSON.parse(res.data.payRes.body);
          await loadAirwallex({
            env: 'prod', // 'staging | 'demo' | 'prod'
          });
          const redirectUrl = redirectToCheckout({
            env: 'prod',
            mode: 'payment', // payment | recurring
            currency: 'USD',
            intent_id: body.intentId,
            client_secret: body.clientSecret,
            successUrl:
              window.location.protocol +
              '//' +
              window.location.host +
              '/payCallback.html',
            // failUrl: window.location.href,
            // cancelUrl: window.location.href,
            disableAutoRedirect: true,
          });
          window.open(redirectUrl);
        } else {
          window.open(res.data.payRes.body);
        }
        Modal.confirm({
          title: '提示',
          icon: null,
          closable: true,
          content: <span>请在新窗口完成充值支付?</span>,
          className: 'daidai-confirm-style',
          cancelText: '支付失败',
          okText: '支付成功',
          centered: true,
          onCancel: () => {
            _get_user_info({ qKey: 'Recharge' });
          },
          onOk: () => {
            _get_user_info({ qKey: 'Recharge' });
          },
        });
      } else {
        message.error(res?.message || '操作失败，请稍后重试哦~');
      }
    });
  };

  //成功之后的回调
  successCallback = (data) => {
    _dssp_send_click(66, {
      orderId: data.orderId,
      pay_fee: data.price,
      diamond_amount: data.price * 100,
      pay_type: data.payType,
    });
    if (this.props.reload) {
      this.props.reload(1, true);
    }
    _get_user_info({ qKey: 'Recharge' });
    this.firstSuccessEle.showModal(data.orderId);
  };
  //显示 关闭 首充福利
  changeScVisible = () => {
    const url = '/h5firstcharge/index.html';
    let modalurl = this.props.base.rootConfig.mobilePath + url;

    _h5_link_to(modalurl).then((res) => {
      window.addEventListener('message', this.openCharge);
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params), {
        zIndex: 1006,
      });
    });
  };
  openCharge = (msg) => {
    if (msg?.data?.key === 'recharge') {
      this.iframeElement.hideModal();
    }
  };
  getCurUnit = (area) => {
    let unit = '';
    const { areaType } = this.state;
    switch (areaType) {
      case 'CN_ABROAD':
      case 'CN_INLAND':
        unit = '￥';
        break;
      case 'US':
        unit = '$';
        break;
      case 'MY':
        unit = 'MYR';
        break;
      case 'TW':
        unit = '台币';
        break;
      default:
        break;
    }
    return unit;
  };

  // 支付方式dom
  payDomRender = () => {
    const { payList, payId } = this.state;

    const payTypeList = {
      /* 马来西亚 */
      7: 'boost',
      10: 'touch',
      11: 'grabpay',
      12: 'maybank',

      /* 台湾 */
      6: 'mycard',
      32: 'payermax',

      /* 大陆 */
      8: 'weixin',
      9: 'zhifubao',
      17: 'weixin',
      18: 'zhifubao',

      /* 其他 */
      5: 'paypal',

      /* 四合 */
      33: 'sh',
    };

    if (payList && payList.length) {
      return payList.map((item) => {
        const icon = payTypeList[item.id];
        let className = 'item-pay';
        if (!!icon) {
          className += ` item-pay-${icon}`;
        }
        if (payId === item.id) {
          className += ` active`;
        }
        return (
          <span
            key={item.id}
            className={className}
            onClick={this.changePayType.bind(this, item)}
          >
            {!!icon ? (
              <span className="icon-pay" />
            ) : (
              <span className="pay-name">{item.name}</span>
            )}
          </span>
        );
      });
    }
    return null;
  };

  // 改变同意状态
  changeRechargeAgreement = (e) => {
    const checked = e.target.checked;
    this.setState({ isRechargeAgreement: checked });
  };
  // 打开协议页面
  openRechargeAgreement = () => {
    const url = '/diamondDeal/index.html';
    const {
      base: { rootConfig },
    } = this.props;
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;

    window.addEventListener('message', this.openCharge);
    this.iframeElement.showModal(modalurl, { zIndex: 1006 });
  };

  // 首充倒计时
  renderFirstChargeDown = () => {
    const { firstChargeTime } = this.state;
    const days = firstChargeTime ? dayjs.duration(firstChargeTime).days() : 0;
    const hours = firstChargeTime ? dayjs.duration(firstChargeTime).hours() : 0;
    const minutes = firstChargeTime
      ? dayjs.duration(firstChargeTime).minutes()
      : 0;
    const seconds = firstChargeTime
      ? dayjs.duration(firstChargeTime).seconds()
      : 0;
    return (
      <div className="down-time-num">
        <span className="text">倒计时：</span>
        <span className="days">{days}天</span>
        <span className="hours">{hours}</span>:
        <span className="minutes">{minutes}</span>:
        <span className="seconds">{seconds}</span>
      </div>
    );
  };

  toShPay = () => {
    const { selAdArray, payType, action, areaCharConfig } = this.state;
    const params = selAdArray?.id
      ? {
          // uid,
          payFee: selAdArray.price,
          diamond: selAdArray.amount,
          payType,
          action,
          origin: 1, // 来源，判断跳转地址  1:PC 2:H5 3:公众号
          configType: 1,
          payItemId: areaCharConfig[0].id,
          merchantCode: 'shwk001',
        }
      : {
          payFee: selAdArray.price,
          diamond: selAdArray.price * 100,
          payType,
          action,
          origin: 1, // 来源，判断跳转地址  1:PC 2:H5 3:公众号
          configType: 1,
          merchantCode: 'shwk001',
        };
    HTTP._create_order_sh(params).then((res) => {
      if (res?.code === 200) {
        this.shElement.hideTipModal();
        window.open(res.data.url);
      } else {
        message.error(res?.message);
        this.shElement.hideTipModal();
      }
    });
  };

  render() {
    const {
      visible,
      selAdArray,
      otherAdItem,
      areaListType,
      areaType,
      payType,
      money,
      areaCharConfig,
      isRechargeAgreement,
      tipVisible,
      isAgree,
      isAgree2,
      isAgree3,
    } = this.state;
    const { userInfo, rootConfig, isChannelSHWB } = this.props.base;
    return (
      <span>
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title="钻石充值"
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="760px"
          onCancel={this.hideModal}
          zIndex={1006}
        >
          <div className="recharge-plan">
            {visible ? (
              <span>
                <div className="frist-reg-el">
                  <Carousel
                    autoplay
                    ref={(el) => (this.rechargeCarouselEle = el)}
                    dots={!!userInfo.userFit}
                  >
                    {!!userInfo.userFit && (
                      <div className="Carousel-item first-charge">
                        <span
                          className="item link"
                          onClick={this.changeScVisible}
                        >
                          {this.renderFirstChargeDown()}
                        </span>
                      </div>
                    )}
                    <div className="Carousel-item">
                      <span className="item app" />
                    </div>
                  </Carousel>
                </div>
                <div className="modal-html">
                  <div className="header-row">
                    <div className="diamondAmount">
                      <label>钱包余额</label>
                      <span>{Util.numberFormat(userInfo.diamondAmount)}</span>
                    </div>
                    {this.state.money ? (
                      <div className="c-money">
                        订单还需支付<label>{this.state.money}</label>元
                      </div>
                    ) : null}
                    <span className="question" onClick={this.showRemark}>
                      <QuestionCircleFilled style={{ fontSize: '18px' }} />
                    </span>
                  </div>
                  {rootConfig.lang != 'zh_CN' ? (
                    <div className="area-type">
                      <label>选择地区</label>
                      {areaListType &&
                        areaListType.map((item) => (
                          <span
                            key={item.area}
                            className={`item-area${areaType === item.area ? ' active' : ''}`}
                            onClick={this.changeAreaType.bind(this, item)}
                          >
                            {item.name}
                          </span>
                        ))}
                    </div>
                  ) : null}

                  <div className="reg-type">
                    <label>支付方式</label>
                    {this.payDomRender()}
                  </div>
                  <div className="reg-items">
                    {areaCharConfig && areaCharConfig.length
                      ? areaCharConfig.map((item, index) => {
                          if ((payType == 5 || payType == 7) && index > 6)
                            return null;
                          return (
                            <div
                              className={
                                selAdArray && selAdArray.id === item.id
                                  ? 'reg-item active'
                                  : 'reg-item'
                              }
                              key={'reg' + item.id}
                              onClick={this.setAdArray.bind(this, item)}
                            >
                              <div className="row">
                                <span className="ds">{item.amount}</span>
                              </div>
                              <div className="row">
                                <label className="price">
                                  {this.getCurUnit(item.area)}
                                  {item.price}
                                </label>
                              </div>
                            </div>
                          );
                        })
                      : null}
                    {(payType == 5 || payType == 7 || isChannelSHWB) && (
                      <div
                        className={
                          selAdArray && selAdArray.index === 7
                            ? 'reg-item active'
                            : 'reg-item'
                        }
                        onClick={this.setAdArray.bind(this, otherAdItem)}
                      >
                        <div className="ibg">
                          <div className="row" style={{ height: '30px' }}>
                            {otherAdItem?.price ? (
                              <span className="ds2">
                                {Util.numberFormat(otherAdItem.price * 100)}
                              </span>
                            ) : (
                              <span className="ds1">其他金额</span>
                            )}
                          </div>
                          <div className="row">
                            <label className="price1">
                              ￥
                              <input
                                type="text"
                                autoComplete="off"
                                value={otherAdItem.price}
                                maxLength="5"
                                onChange={this.changeFormValue}
                              />
                            </label>
                          </div>
                        </div>
                        {money ? <span className="tj"></span> : null}
                      </div>
                    )}
                  </div>
                  <div className="reg-agreement">
                    <Checkbox
                      defaultChecked={isRechargeAgreement}
                      onChange={this.changeRechargeAgreement}
                      style={{ marginLeft: 10 }}
                    />
                    同意{' '}
                    <span
                      className="link-text"
                      onClick={this.openRechargeAgreement}
                    >
                      充值服务协议
                    </span>
                  </div>
                  <div className="reg-actions">
                    <Button
                      className="daidai-btn-primary" 
                      onClick={this.toCodePay}
                      loading={this.state.loading}
                    >
                      立即支付
                    </Button>
                  </div>
                </div>
                <div className="first-remark">
                  <p>
                    1.首充活动期间，所有用户第一笔充值均为首充，每个用户仅每档奖励最多只能领取一次。
                  </p>
                  <p>
                    2.礼包所有包含的礼物，充值获得后可在房间-礼物栏-背包中查看。
                  </p>
                </div>
              </span>
            ) : null}
          </div>
        </Modal>
        <ShModal
          ref={(el) => (this.shElement = el)}
          toShPay={this.toShPay}
        />
        {/* 支付二维码 */}
        <CodePay
          ref={(el) => (this.payElement = el)}
          base={this.props.base}
          successCallback={this.successCallback}
        />
        {/* 货币说明 */}
        <ConfrimIframeModal
          wrappedComponentRef={(el) => (this.confirmElement = el)}
        />
        {/* 首充  */}
        <MaxIframeModal wrappedComponentRef={(el) => (this.maxElement = el)} />
        {/* 首充成功展示弹窗 */}
        <FirstRechargeSuccess
          wrappedComponentRef={(el) => (this.firstSuccessEle = el)}
          base={this.props.base}
          closeModal={this.hideModal}
          showMyCenter={this.props.showMyCenter || null}
        />
        {/* 通用弹窗 */}
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
      </span>
    );
  }
}

export default withRouter(Recharge, { withRef: true });
